import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './general.actions';
import { ProductLine } from '@core/models/swagger';
import { MultiQuoteResponse, SearchPartnerResponse } from '@core/models/swagger/bff';
import cloneDeep from 'clone-deep';

export interface State {
  selectedProductLine: ProductLine | null;
  productLines: MultiQuoteResponse | null;
  partnerSearchObject: SearchPartnerResponse | null;
  progressId: number;
  fullOperationId: string | null;
  quotingId: string;
  prevUrl: string | null;
}

export const featureKey = 'flowDataGeneral';

export const initialState: State = {
  selectedProductLine: null,
  productLines: null,
  partnerSearchObject: null,
  progressId: 0,
  fullOperationId: null,
  quotingId: null,
  prevUrl: null,
};

export function generalReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.ResetGeneral, (state, {}) => ({
      ...state,
      selectedPackage: null,
      prevUrl: null,
    })),
    on(Actions.UpdateSelectedProductLine, (state, { data }) => ({
      ...state,
      selectedProductLine: data,
    })),
    on(Actions.UpdatePartnerSearchResponse, (state, { data }) => ({
      ...state,
      partnerSearchObject: data,
    })),
    on(Actions.UpdateProgressId, (state, { data }) => ({
      ...state,
      progressId: data,
    })),
    on(Actions.UpdateFullOperationId, (state, { data }) => ({
      ...state,
      fullOperationId: data,
    })),
    on(Actions.UpdateQuotingId, (state, { data }) => ({
      ...state,
      quotingId: cloneDeep(data),
    })),
    on(Actions.UpdateProductLines, (state, { data }) => ({
      ...state,
      productLines: cloneDeep(data),
    })),
    on(Actions.UpdatePrevUrl, (state, { data }) => ({
      ...state,
      prevUrl: data,
    }))
  )(state, action);
}
